export default __webpack_public_path__ + "static/media/showpanel_PC.2dae6caa.svg";